import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/api";
import { Bell, X, CheckCheck } from "lucide-react";

export default function NotificationBell() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({ notifications: [], unread: 0 });
  const ref = useRef();
  const navigate = useNavigate();

  const load = async () => {
    try { const { data } = await api.get("/notifications"); setData(data); } catch {}
  };
  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, []);

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const openLink = async (n) => {
    await api.post(`/notifications/${n.id}/read`).catch(() => {});
    setOpen(false);
    if (n.link) navigate(n.link);
  };

  const markAll = async () => {
    await api.post("/notifications/read-all").catch(() => {});
    load();
  };

  return (
    <div className="relative" ref={ref}>
      <button data-testid="notification-bell" onClick={() => setOpen((o) => !o)} className="relative h-9 w-9 rounded-lg glass flex items-center justify-center text-slate-300 hover:text-amber-300 transition">
        <Bell size={17} />
        {data.unread > 0 && <span className="absolute -top-1 -right-1 h-4 min-w-4 px-1 rounded-full bg-[#264194] text-white text-[9px] font-bold flex items-center justify-center" data-testid="notification-count">{data.unread}</span>}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-80 max-h-96 overflow-y-auto glass rounded-2xl p-3 z-50 shadow-xl" data-testid="notification-panel">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-semibold text-slate-100">Notifications</span>
            <div className="flex items-center gap-2">
              {data.unread > 0 && <button onClick={markAll} className="text-[11px] text-[var(--jjs-gold-deep)] flex items-center gap-1" data-testid="notification-readall"><CheckCheck size={12} /> Mark all</button>}
              <button onClick={() => setOpen(false)} className="text-slate-400"><X size={16} /></button>
            </div>
          </div>
          {data.notifications.length === 0 ? (
            <p className="text-slate-400 text-sm py-6 text-center">No notifications yet.</p>
          ) : (
            <div className="space-y-2">
              {data.notifications.map((n) => (
                <button key={n.id} onClick={() => openLink(n)} data-testid={`notification-${n.id}`} className={`w-full text-left rounded-xl p-3 border transition ${n.read ? "border-[var(--jjs-border)] bg-transparent opacity-70" : "border-[rgba(198,161,91,.45)] bg-[var(--jjs-gold-tint)]"}`}>
                  <div className="text-[13px] font-medium text-slate-100">{n.title}</div>
                  <div className="text-xs text-slate-500 whitespace-pre-line mt-0.5 line-clamp-3">{n.body}</div>
                  <div className="text-[10px] text-slate-400 mt-1">{new Date(n.created_at).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}</div>
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
